/**
 * WIP
 */

import { Localisation, UserData } from '../types/user'
import { TrybaShop } from '../types/shop'

export const setUserDataLocalisation = (localisation?: Localisation): void => {
    const userData: string | null = window.localStorage.getItem('user_data');
    if (userData === null) {
        const userDataObject: UserData = {
            localisation: localisation || null,
            shop: null,
            favorites: null,
        };
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    } else {
        const userDataObject = JSON.parse(userData) as UserData;
        userDataObject.localisation = localisation || null;
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    }
}

export const setUserFavorites = (key: string, favorites: object) => {
    const userData: string | null = window.localStorage.getItem('user_data');

    if (userData === null) {
        const userDataObject: UserData = {
            localisation: null,
            shop: null,
            favorites: {
                doors: key === 'doors' ? favorites : null,
            },
        };
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    } else {
        const userDataObject = JSON.parse(userData) as UserData;

        if (userDataObject.favorites === null) {
            userDataObject.favorites = {
                doors: null,
            };
        }

        if (typeof userDataObject.favorites === 'undefined') {
            userDataObject.favorites = {
                doors: null,
            };
        }

        userDataObject.favorites[key] = favorites;
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    }
};

export const removeUserShop = (): void => {
    const userData: string | null = window.localStorage.getItem('user_data');
    if (userData !== null) {
        const userDataObject = JSON.parse(userData) as UserData;
        userDataObject.shop = null;
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    }
}

export const setUserDataShop = (phone: string|null|undefined, zip: string, city: string, address: string, name: string, code: string, url: string, latitude: string, longitude: string): void => {
    const userData: string | null = window.localStorage.getItem('user_data');

    let userDataObject;

    if (userData !== null) {
        userDataObject = JSON.parse(userData) as UserData;

        // return userData with the new property updated
        userDataObject['shop'] = {
            name: name,
            clientNumber: code,
            url: url,
            address: address,
            zip: zip,
            city: city,
            phone: phone || '',
            latitude: latitude,
            longitude: longitude,
        } as TrybaShop;
        window.localStorage.setItem('user_data', JSON.stringify(userDataObject));
    } else {
        userDataObject = {
            localisation: null,
            shop: {
                name: name,
                clientNumber: code,
                url: url,
                address: address,
                zip: zip,
                city: city,
                phone: phone || '',
                latitude: latitude,
                longitude: longitude,
            },
        };

        window.localStorage.setItem('user_data', JSON.stringify(userDataObject as UserData));
    }
}

export const createUserDataObjectFromPDVPage = (shopPhone: string, shopZip: string, shopCity: string, address: string, name: string, code: string, slug: string, latitude: string, longitude: string): UserData => {
    const departement = shopZip.slice(0, 2)
    return {
        localisation: null,
        shop: {
            name: name,
            clientNumber: code,
            url: '/espace-conseil/' + departement + '/' + slug + '/',
            address: address,
            zip: shopZip,
            city: shopCity,
            phone: shopPhone,
            latitude: latitude,
            longitude: longitude
        }
    } as UserData;
}

export const setUserDataInLocalStorage = (userData: UserData): void => {
    console.trace('user_data set');
    window.localStorage.setItem('user_data', JSON.stringify(userData));
}

export const getUserData = (): UserData|null => {
    const userData: string | null = window.localStorage.getItem('user_data');
    if (userData !== null) {
        try {
            return JSON.parse(userData) as UserData;
        } catch (e) {
            console.log('Error parsing user data from localStorage', e);
            return null;
        }
    }
    return null;
}

export const getUserFavorites = (key: string) => {
    const userData = getUserData();

    if (userData !== null && userData.favorites !== null && userData.favorites !== undefined && userData.favorites[key] !== undefined) {
        return userData.favorites[key];
    }

    return null;
};
